export enum InventoryClass {
  ClassA = 'A',
  ClassB = 'B',
  ClassC = 'C',
}
